<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-right">
                <b-button-group>
                    <b-button  v-if="Core.Session.AuthUser.can('contract_management_post')" @click="add" class="btn btn-light">{{Core.Definition.getDefinition('Nouveau gabarit')}}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'ContractTemplateContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/contrat/gabarits/nouveau-gabarit')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/contrat/gabarits/nouveau-gabarit'))
                }
            },
            contractTemplateList() {
                this.$router.push(window.Core.Definition.getDefinition('/contrat/gabarits'))
            }
        }
    }
</script>
